<!-- -->
<template>
  <el-date-picker :model-value="time" @update:modelValue="changeTime" @change="changeTime"
                  :type="type" :placeholder="placeholder"

  ></el-date-picker>
</template>

<script>
  import dayjs from "dayjs"

  export default {
    props: {
      modelValue: String,
      placeholder: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      //禁用类型 0小于当前时间禁用 1大于当前时间禁用 2小于当前日期禁用 不包括今天
      disabledType: {
        type: String,
        default: "0",
      },
      valueFormat: {
        type: String,
        default: "YYYY-MM-DD HH:mm:ss"
      },
      //可选日期
      selectDate:{
        type:Array,
      },
      type:{
        type:String,
        default:"datetime"
      }
    },
    name: "OneDatePicker",
    data() {
      return {
        time:null,
      }
    },
    watch:{
      modelValue(n){
        this.time = n?new Date(n):null;
      }
    },
    mixins: [tableBase],
    methods: {
      changeTime(value){
        this.time = value;
        if(value){
          this.$emit('update:modelValue',dayjs(value).format(this.valueFormat))
        }else{
          this.$emit('update:modelValue',null);
        }
      }
    },
    mounted() {

    }
  }
</script>

<style lang="less" scoped>

</style>
